import React, { useContext } from 'react'
import CreateNewGallery from './CreateNewGallery'
import { Context } from "../contexts/AppContext";

function GalleryHeader() {
   const { value } = useContext(Context);
      const [appState, setAppState] = value;

    const closeCreateNewGalleryPage=()=>{
        setAppState((prevState) => ({ ...prevState,
            modalData:{ ...prevState.modalData, type: "NewGalleryModal", isOpen: true, galeryUpdate:true}}
          ));
    }
    
  return (
    <div className='flex items-end px-5  py-2 justify-between border border-b-gray-200'>
      <div>{appState.currentFolderName}</div>
        <div >
        <CreateNewGallery closeCreateNewGalleryPage={closeCreateNewGalleryPage}/>
        </div>
    </div>
  )
}

export default GalleryHeader